import fireAnalytics from '~/services/analytics/fireAnalytics';

export const fireVisitedTradeInEventsPage = () =>
  fireAnalytics('Visited Trade-in Events');
